module.exports = __webpack_public_path__ + "img/maintenance.f2e2add1.gif";